import { TagInput as AntdTagInput } from "@empglabs/backoffice-ui-kit"

const TagInput = props => {
  return <AntdTagInput {...props} />
}

export default TagInput
